import React from "react";
import { tWithKeyAttr as t } from "../../../../i18nHelper";
import styles from "../../appointmentsPage.module.css";

interface IAutoReminderToggleProps {
  isEnabled: boolean;
  onToggle: (enabled: boolean) => void;
}

/**
 * Toggle switch for automatic high-risk reminders
 */
const AutoReminderToggle: React.FC<IAutoReminderToggleProps> = ({ isEnabled, onToggle }) => {
  return (
    <div className={styles.autoReminderToggle}>
      <div className={styles.toggleInfo}>
        <div className={styles.toggleTitle}>
          📧 {t("NOSHOW_AUTO_REMINDERS_TITLE")}
        </div>
        <div className={styles.toggleDescription}>
          {t("NOSHOW_AUTO_REMINDERS_DESC")}
        </div>
      </div>
      <button
        className={`${styles.toggleSwitch} ${isEnabled ? styles.active : ''}`}
        onClick={() => onToggle(!isEnabled)}
        role="switch"
        aria-checked={isEnabled}
      >
        <span className={styles.toggleKnob} />
      </button>
    </div>
  );
};

export default AutoReminderToggle;
